import { DatePicker, DatePickerProps } from "antd";
import dayjs from "dayjs";
import React from "react";
import { HTMLProps } from "../../../model/HTMLProps";

export interface DatePickerPlainProps extends HTMLProps {
  value?: number | null;
  onChange?: (ms?: number | null) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
}

export const DatePickerPlain = (props: DatePickerPlainProps) => {
  const onChange: DatePickerProps["onChange"] = (date) => {
    if (props.onChange) {
      props.onChange(date ? date.valueOf() : null);
    }
  };

  const getValue = () => {
    return props.value ? dayjs(props.value) : undefined;
  };

  return (
    <DatePicker
      value={getValue()}
      onChange={onChange}
      className={props.className}
      placeholder={props.placeholder}
      showTime
      required={props.required}
      picker="date"
      disabled={props.disabled}
    />
  );
};
